import React from 'react';
import './card.css';
import global from '../../assets/images/global.png';
import './card.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faAddressCard } from '@fortawesome/free-solid-svg-icons';

export default function CardInput(props) {
  const heig = 135;
  return (
    <>
      <div
        style={{ height: `${heig}px` }}
        className="cardContainer cardInput"
      >
        <div className="addLogo">
          {/* <img src={props.icon==="phone"?phone:''} alt=""/> */}
          <img src={props.icon==="global"?global:''} alt=""/>
          {props.icon ==="phone" && <FontAwesomeIcon
                            icon={faAddressCard}
                            color="#2691a3"
                            size="3x"
                          />}
        </div>

        <div className="CardInput">
          <input required type="text" name={props.names} onChange={props.handleChange} defaultValue={props?.name}/>
          <label>{props.title}</label>
        </div>
      </div>
    </>
  );
}
